Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="formio-loader">\n  <div class="loader-wrapper">\n    <div class="ui active centered inline loader"></div>\n  </div>\n</div>\n';
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/@formio/semantic/lib/templates/semantic/loader/form.ejs.js
// module id = 1668
// module chunks = 0